import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import selectors from '../selectors';
import entryActions from '../entry-actions';
import { BoardMembershipRoles } from '../constants/Enums';
import Card from '../components/Card';

const makeMapStateToProps = () => {
  const selectCardById = selectors.makeSelectCardById();
  const selectUsersByCardId = selectors.makeSelectUsersByCardId();
  const selectLabelsByCardId = selectors.makeSelectLabelsByCardId();
  const selectTasksByCardId = selectors.makeSelectTasksByCardId();
  const selectNotificationsTotalByCardId = selectors.makeSelectNotificationsTotalByCardId();
  const selectPointsDataByCardId = selectors.makeSelectPointsDataByCardId();

  return (state, { id, index }) => {
    const { projectId } = selectors.selectPath(state);
    const allProjectsToLists = selectors.selectProjectsToListsForCurrentUser(state);
    const allBoardMemberships = selectors.selectMembershipsForCurrentBoard(state);
    const allLabels = selectors.selectLabelsForCurrentBoard(state);
    const currentUserMembership = selectors.selectCurrentUserMembershipForCurrentBoard(state);
    const currentUser = selectors.selectCurrentUser(state);
    const { name, dueDate, createdAt, stopwatch, coverUrl, boardId, listId, isPersisted } = selectCardById(
      state,
      id,
    );
    const users = selectUsersByCardId(state, id);
    const labels = selectLabelsByCardId(state, id);
    const tasks = selectTasksByCardId(state, id);
    const notificationsTotal = selectNotificationsTotalByCardId(state, id);
    const isSAdmin = currentUser.isSAdmin;

    const isCurrentUserEditor = isSAdmin === true ? true : (
      !!currentUserMembership && currentUserMembership.role === BoardMembershipRoles.EDITOR);

    const pointSystem = selectors.selectPointSystemForCurrentBoard(state);
    const isPointSystemEnabled = pointSystem?.isEnabled === true;
    // Получаем cardPointData независимо от состояния балльной системы (isEnabled)
    const cardPointData = pointSystem
      ? selectors.selectCardPointDataForCardAndPointSystem(state, id, pointSystem.id)
      : null;
    // Показываем зеленый контур для закрытых задач в любом случае (PointSystem.is_enabled = true|false)
    const isClosed = cardPointData?.closed === true;
    const cardPointArchivedData = pointSystem
      ? selectors.selectCardPointArchivedDataForCardAndPointSystem(state, id, pointSystem.id)
      : null;
    const taskClosedAt = cardPointArchivedData?.taskClosedAt || cardPointData?.closedAt || null;

    // Получаем данные о баллах
    const pointsData = pointSystem
      ? selectPointsDataByCardId(state, id, pointSystem.id)
      : null;
    console.log(`[CardContainer] cardId: ${id}, pointsData:`, pointsData);

    return {
      id,
      index,
      name,
      dueDate,
      createdAt,
      stopwatch,
      coverUrl,
      boardId,
      listId,
      projectId,
      isPersisted,
      notificationsTotal,
      users,
      labels,
      tasks,
      allProjectsToLists,
      allBoardMemberships,
      allLabels,
      canEdit: isCurrentUserEditor,
      isClosed,
      taskClosedAt,
      pointsData,
      isPointSystemEnabled,
    };
  };
};

const mapDispatchToProps = (dispatch, { id }) =>
  bindActionCreators(
    {
      onUpdate: (data) => entryActions.updateCard(id, data),
      onMove: (listId, index) => entryActions.moveCard(id, listId, index),
      onTransfer: (boardId, listId) => entryActions.transferCard(id, boardId, listId),
      onDelete: () => entryActions.deleteCard(id),
      onArchive: () => entryActions.archiveCard(id),
      onClone: () => entryActions.cloneCard(id),
      onUserAdd: (userId) => entryActions.addUserToCard(userId, id),
      onUserRemove: (userId) => entryActions.removeUserFromCard(userId, id),
      onBoardFetch: entryActions.fetchBoard,
      onLabelAdd: (labelId) => entryActions.addLabelToCard(labelId, id),
      onLabelRemove: (labelId) => entryActions.removeLabelFromCard(labelId, id),
      onLabelCreate: (data) => entryActions.createLabelInCurrentBoard(data),
      onLabelUpdate: (labelId, data) => entryActions.updateLabel(labelId, data),
      onLabelMove: (labelId, index) => entryActions.moveLabel(labelId, index),
      onLabelDelete: (labelId) => entryActions.deleteLabel(labelId),
    },
    dispatch,
  );

export default connect(makeMapStateToProps, mapDispatchToProps)(Card);
